import React from 'react'
import { Link } from 'react-router-dom'
import { Package, Cog, Lightbulb, Shield, TrendingUp, Users, ArrowRight } from 'lucide-react'

const ServicesPage = () => {
  const services = [
    {
      icon: Package,
      title: 'Özel Tasarım Ambalaj',
      description: 'Müşterilerimizin özel ihtiyaçlarına göre tasarlanan, marka kimliğinizi yansıtan ambalaj çözümleri. Ar-Ge ekibimiz, ürününüze en uygun ambalaj tasarımını geliştirir.',
      features: [
        'Marka kimliğine uygun tasarım',
        'Özel renk ve baskı seçenekleri',
        'Ergonomik ve fonksiyonel tasarım',
        'Prototip üretim ve test'
      ],
      image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&q=80'
    },
    {
      icon: Cog,
      title: 'IML (In-Mould Labelling) Teknolojisi',
      description: 'Etiketin kalıp içinde ambalaja entegre edildiği ileri teknoloji üretim yöntemi. Dayanıklı, estetik ve hijyenik ambalaj çözümleri sunuyoruz.',
      features: [
        '360° yüksek kaliteli baskı',
        'Soyulmayan, dayanıklı etiket',
        'Gıda güvenliği standartlarına uygun',
        'Hızlı üretim süreci'
      ],
      image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=800&q=80'
    },
    {
      icon: Shield,
      title: 'UN Onaylı Tehlikeli Madde Ambalajları',
      description: 'Uluslararası standartlara uygun, test edilmiş ve sertifikalandırılmış tehlikeli madde taşıma ambalajları. Güvenli taşıma için tam uyumluluk.',
      features: [
        'UN sertifikalı ambalajlar',
        'Paketleme Grubu I, II, III',
        'Düzenli test ve sertifikasyon',
        'Yasal uyumluluk garantisi'
      ],
      image: 'https://images.unsplash.com/photo-1578575437130-527eed3abbec?w=800&q=80'
    },
    {
      icon: Lightbulb,
      title: 'Ar-Ge ve Ürün Geliştirme',
      description: 'Sürekli yenilik ve gelişim odaklı Ar-Ge çalışmalarımızla sektörde öncü çözümler sunuyoruz. Müşteri ihtiyaçlarına özel ürün geliştirme hizmetleri.',
      features: [
        'Malzeme optimizasyonu',
        'Sürdürülebilir alternatifler',
        'Maliyet-performans analizi',
        'Prototip ve test hizmetleri'
      ],
      image: 'https://images.unsplash.com/photo-1532996122724-e3c354a0b15b?w=800&q=80'
    },
    {
      icon: TrendingUp,
      title: 'Kalite Kontrol ve Test Hizmetleri',
      description: 'Akredite laboratuvarlarımızda kapsamlı kalite kontrol ve test hizmetleri. Her üretim aşamasında titiz kalite güvencesi.',
      features: [
        'Mekanik dayanım testleri',
        'Kimyasal uyumluluk testleri',
        'Düşme ve istif testleri',
        'Sızdırmazlık testleri'
      ],
      image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=800&q=80'
    },
    {
      icon: Users,
      title: 'Teknik Danışmanlık',
      description: '50+ yıllık deneyimimizle müşterilerimize kapsamlı teknik danışmanlık hizmeti sunuyoruz. Ambalaj seçiminden lojistiğe kadar tüm süreçlerde destek.',
      features: [
        'Ambalaj seçim danışmanlığı',
        'Maliyet optimizasyonu',
        'Lojistik planlama desteği',
        'Yasal uyumluluk danışmanlığı'
      ],
      image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80'
    }
  ]

  return (
    <div data-component-path="client/src/pages/ServicesPage.jsx" data-component-line="1:1" data-component-id="client/src/pages/ServicesPage.jsx:1:1" className="min-h-screen">
      <section data-component-path="client/src/pages/ServicesPage.jsx" data-component-line="2:2" data-component-id="client/src/pages/ServicesPage.jsx:2:2" 
        className="relative h-96 bg-cover bg-center flex items-center"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=1600&q=80)'
        }}
      >
        <div data-component-path="client/src/pages/ServicesPage.jsx" data-component-line="3:3" data-component-id="client/src/pages/ServicesPage.jsx:3:3" className="absolute inset-0 bg-blue-900/70"></div>
        <div data-component-path="client/src/pages/ServicesPage.jsx" data-component-line="4:4" data-component-id="client/src/pages/ServicesPage.jsx:4:4" className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-white">
          <h1 data-component-path="client/src/pages/ServicesPage.jsx" data-component-line="5:5" data-component-id="client/src/pages/ServicesPage.jsx:5:5" className="text-5xl font-bold mb-4">Hizmetlerimiz</h1>
          <p data-component-path="client/src/pages/ServicesPage.jsx" data-component-line="6:6" data-component-id="client/src/pages/ServicesPage.jsx:6:6" className="text-xl">Kapsamlı ambalaj çözümleri ve profesyonel hizmetler</p>
        </div>
      </section>

      <section data-component-path="client/src/pages/ServicesPage.jsx" data-component-line="7:7" data-component-id="client/src/pages/ServicesPage.jsx:7:7" className="py-20 bg-white">
        <div data-component-path="client/src/pages/ServicesPage.jsx" data-component-line="8:8" data-component-id="client/src/pages/ServicesPage.jsx:8:8" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div data-component-path="client/src/pages/ServicesPage.jsx" data-component-line="9:9" data-component-id="client/src/pages/ServicesPage.jsx:9:9" className="text-center mb-16">
            <h2 data-component-path="client/src/pages/ServicesPage.jsx" data-component-line="10:10" data-component-id="client/src/pages/ServicesPage.jsx:10:10" className="text-4xl font-bold text-gray-900 mb-4">
              Profesyonel Ambalaj Hizmetleri
            </h2>
            <p data-component-path="client/src/pages/ServicesPage.jsx" data-component-line="11:11" data-component-id="client/src/pages/ServicesPage.jsx:11:11" className="text-xl text-gray-600 max-w-3xl mx-auto">
              50 yılı aşkın deneyimimizle, plastik ve metal ambalaj sektöründe ihtiyacınıza özel çözümler sunuyoruz. Modern üretim tesislerimiz ve uzman ekibimizle, en yüksek kalite standartlarında hizmet veriyoruz.
            </p>
          </div>

          <div data-component-path="client/src/pages/ServicesPage.jsx" data-component-line="12:12" data-component-id="client/src/pages/ServicesPage.jsx:12:12" className="space-y-16">
            {services.map((service, index) => (
              <div data-component-path="client/src/pages/ServicesPage.jsx" data-component-line="13:13" data-component-id="client/src/pages/ServicesPage.jsx:13:13" 
                key={index}
                className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-8 items-center`}
              >
                <div data-component-path="client/src/pages/ServicesPage.jsx" data-component-line="14:14" data-component-id="client/src/pages/ServicesPage.jsx:14:14" className="lg:w-1/2">
                  <img data-component-path="client/src/pages/ServicesPage.jsx" data-component-line="15:15" data-component-id="client/src/pages/ServicesPage.jsx:15:15"
                    src={service.image}
                    alt={service.title}
                    className="w-full h-80 object-cover rounded-2xl shadow-lg"
                    onError={(e) => {
                      e.target.onerror = null
                      e.target.src = 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=800&q=80'
                    }}
                  />
                </div>

                <div data-component-path="client/src/pages/ServicesPage.jsx" data-component-line="16:16" data-component-id="client/src/pages/ServicesPage.jsx:16:16" className="lg:w-1/2">
                  <div data-component-path="client/src/pages/ServicesPage.jsx" data-component-line="17:17" data-component-id="client/src/pages/ServicesPage.jsx:17:17" className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-6">
                    <service.icon className="w-8 h-8 text-blue-600" />
                  </div>

                  <h3 data-component-path="client/src/pages/ServicesPage.jsx" data-component-line="18:18" data-component-id="client/src/pages/ServicesPage.jsx:18:18" className="text-3xl font-bold text-gray-900 mb-4">
                    {service.title}
                  </h3>

                  <p data-component-path="client/src/pages/ServicesPage.jsx" data-component-line="19:19" data-component-id="client/src/pages/ServicesPage.jsx:19:19" className="text-lg text-gray-600 mb-6">
                    {service.description}
                  </p>

                  <ul data-component-path="client/src/pages/ServicesPage.jsx" data-component-line="20:20" data-component-id="client/src/pages/ServicesPage.jsx:20:20" className="space-y-3 mb-6">
                    {service.features.map((feature, fIndex) => (
                      <li data-component-path="client/src/pages/ServicesPage.jsx" data-component-line="21:21" data-component-id="client/src/pages/ServicesPage.jsx:21:21" key={fIndex} className="flex items-start gap-3">
                        <div data-component-path="client/src/pages/ServicesPage.jsx" data-component-line="22:22" data-component-id="client/src/pages/ServicesPage.jsx:22:22" className="flex-shrink-0 w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mt-1">
                          <svg data-component-path="client/src/pages/ServicesPage.jsx" data-component-line="23:23" data-component-id="client/src/pages/ServicesPage.jsx:23:23" className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path data-component-path="client/src/pages/ServicesPage.jsx" data-component-line="24:24" data-component-id="client/src/pages/ServicesPage.jsx:24:24" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                          </svg>
                        </div>
                        <span data-component-path="client/src/pages/ServicesPage.jsx" data-component-line="25:25" data-component-id="client/src/pages/ServicesPage.jsx:25:25" className="text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>

                  <Link data-component-path="client/src/pages/ServicesPage.jsx" data-component-line="26:26" data-component-id="client/src/pages/ServicesPage.jsx:26:26"
                    to="/iletisim"
                    className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 font-semibold"
                  >
                    Detaylı Bilgi Alın
                    <ArrowRight className="w-5 h-5" />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section data-component-path="client/src/pages/ServicesPage.jsx" data-component-line="27:27" data-component-id="client/src/pages/ServicesPage.jsx:27:27" className="py-20 bg-blue-600">
        <div data-component-path="client/src/pages/ServicesPage.jsx" data-component-line="28:28" data-component-id="client/src/pages/ServicesPage.jsx:28:28" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h2 data-component-path="client/src/pages/ServicesPage.jsx" data-component-line="29:29" data-component-id="client/src/pages/ServicesPage.jsx:29:29" className="text-4xl font-bold mb-4">
            Ambalaj İhtiyaçlarınız İçin Bizimle İletişime Geçin
          </h2>
          <p data-component-path="client/src/pages/ServicesPage.jsx" data-component-line="30:30" data-component-id="client/src/pages/ServicesPage.jsx:30:30" className="text-xl mb-8 text-blue-100">
            Uzman ekibimiz size en uygun çözümü sunmak için hazır
          </p>
          <Link data-component-path="client/src/pages/ServicesPage.jsx" data-component-line="31:31" data-component-id="client/src/pages/ServicesPage.jsx:31:31"
            to="/iletisim"
            className="inline-flex items-center justify-center gap-2 h-14 px-8 bg-white text-blue-600 rounded-lg hover:bg-gray-100 transition-all duration-200 font-semibold shadow-lg hover:shadow-xl"
          >
            Hemen Teklif Alın
            <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </section>
    </div>
  )
}

export default ServicesPage